import { roleDetailConstants } from '../../_constants';

export function roleDetail(state = {}, action) {
    switch (action.type) {
        case roleDetailConstants.ROLE_DETAIL_FETCHING:
            return {
                ...state,
                fetchingRoleDetail: true
            };
        case roleDetailConstants.ROLE_DETAIL_FETCHED:
            return {
                ...state,
                fetchingRoleDetail: false
            };
        case roleDetailConstants.GET_ROLEDETAIL:
            return {
                ...state,
                roleDetail: action.roleDetail,
            };
        case roleDetailConstants.GET_ROLEDETAIL_MENUID:
            return {
                ...state,
                roleDetailByMenuId: action.roleDetailByMenuId,
            };
        case roleDetailConstants.GET_ROLEDETAILMENU:
            return {
                ...state,
                roleDetailMenu: action.roleDetailMenu,
            };
        default:
            return state;
    }
}